<template>
    <div class="attivita-container">
        <!-- Header dell'attività -->
        <div class="d-flex align-items-center p-2 bg-light rounded cursor-pointer"
             @click="toggleExpanded()"
             :style="{ paddingLeft: (level * 1.5 + 0.75) + 'rem' }">
            <i v-if="hasSubItems"
               :class="expanded ? 'ph-caret-down' : 'ph-caret-right'"
               class="me-2"></i>
            <i v-else class="me-2" style="width: 1em;"></i>

            <strong style="flex: 1;">{{ attivita.TITOLO }}</strong>

            <div class="d-flex gap-2">
                <span v-if="hasVoci" class="badge bg-secondary">{{ attivita.VOCI.length }} {{ utils.plurale(attivita.VOCI.length, 'voce', 'voci') }}</span>
                <span v-if="hasSottoAttivita" class="badge bg-info">{{ attivita.SOTTO_ATTIVITA.length }} {{ utils.plurale(attivita.SOTTO_ATTIVITA.length, 'sottoattività', 'sottoattività') }}</span>
            </div>
        </div>

        <!-- Contenuto espanso -->
        <div v-if="expanded" :style="{ paddingLeft: (level * 1.5 + 0.75) + 'rem' }" class="expanded-content">
            <!-- Sottoattività -->
            <div v-if="hasSottoAttivita" class="sotto-attivita-container">
                <TabAttvitaSchedaVisualizzazioneProgetto
                    v-for="sotto in attivita.SOTTO_ATTIVITA"
                    :key="sotto.ID_ATTIVITA"
                    :attivita="sotto"
                    :filters="filters"
                    :level="level + 1"
                    :force-expanded="forceExpanded"
                    @toggle="$emit('toggle')"
                />
            </div>

            <!-- Voci -->
            <div v-if="hasVoci" class="mt-2 table-responsive">
                <table class="table table-sm table-hover mb-0">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 46%">Titolo Voce</th>
                            <th style="width: 10%">Qta</th>
                            <th style="width: 10%">Rip.</th>
                            <th style="width: 17%">Prezzo Unit.</th>
                            <th style="width: 17%">Totale</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="voce in attivita.VOCI" :key="voce.ID_VOCE">
                            <td class="fs-sm">
                                <i class="ph-file-text me-1 text-muted"></i>
                                {{ voce.TITOLO_VOCE }}
                            </td>
                            <td class="fs-sm">{{ voce.QUANTITY_PRICE || '-' }}</td>
                            <td class="fs-sm">{{ voce.DAYS_PRICE || '-' }}</td>
                            <td class="fs-sm">&euro; {{ filters.formattaImporto(voce.UNIT_PRICE) }}</td>
                            <td class="fs-sm fw-bold">&euro; {{ filters.formattaImporto(voce.TOTAL_PRICE) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Messaggio se non c'è nulla -->
            <div v-if="!hasVoci && !hasSottoAttivita" class="text-muted p-2 mt-2">
                Nessun contenuto disponibile
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabAttivitaSchedaVisualizzazioneProgetto",
    props: {
        attivita: {
            type: Object,
            required: true
        },
        filters: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        forceExpanded: {
            type: Boolean,
            default: null
        }
    },
    emits: ['toggle'],
    watch: {
        forceExpanded: {
            immediate: true,
            handler(val) {
                if (val != null) this.expanded = val;
            }
        }
    },
    data() {
        return {
            expanded: false,
            utils: global.utils
        }
    },
    computed: {
        hasVoci() {
            return this.attivita.VOCI && this.attivita.VOCI.length > 0;
        },
        hasSottoAttivita() {
            return this.attivita.SOTTO_ATTIVITA && this.attivita.SOTTO_ATTIVITA.length > 0;
        },
        hasSubItems() {
            return this.hasVoci || this.hasSottoAttivita;
        }
    },
    methods: {
        toggleExpanded() {
            if (this.hasSubItems) {
                this.expanded = !this.expanded;
                this.$emit('toggle', this.attivita);
            }
        }
    }
}
</script>

<style scoped>
.attivita-container {
    margin-bottom: 0.5rem;
}

.expanded-content {
    margin-top: 0.5rem;
}

.sotto-attivita-container {
    margin-bottom: 0.75rem;
}

.cursor-pointer {
    cursor: pointer;
    transition: background-color 0.2s;
}

.cursor-pointer:hover {
    background-color: #e8e8e8 !important;
}
</style>
